export default __webpack_public_path__ + "static/media/18.03bd4c35.JPG";